<template>
  <div class="login">
    <img src="/weapsmithing/images/logo-xs.png" class="logo" alt="" />

    <button
      type="button"
      class="btn btn-success mt-5"
      @click.prevent="handle_login"
    >
      Login
    </button>
    <p class="w-50 mx-auto text-center mt-5">
      "By using or accessing our website you agree to our
      <a href="https://weaponsmithing.digital/index.php/terms-of-use/"
        >Terms of Use</a
      >"
    </p>
    <p class="w-50 mx-auto text-center mt-5">
      "Develop by 
      <a href="https://codnocrats.com/"
        >Codnocrats</a
      >"
    </p>

    <div id="ual-div"></div>
  </div>
</template>

<script>
// @ is an alias to /src
import LoginService from "../services/LoginService";
export default {
  name: "Login",
  data() {
    return {
      ual: null,
      showPopup: false,
    };
  },
  inheritAttrs: false,
  mounted() {
    localStorage.removeItem("ual-session-authenticator");
    localStorage.removeItem("ual-session-expiration");
    localStorage.removeItem("autoLogin");
    localStorage.removeItem("loglevel:webpack-dev-server");
    localStorage.removeItem("ual-wax:autologin");
    localStorage.removeItem("wax_user");
    localStorage.clear();
    const loginService = new LoginService();
    this.ual = loginService.handle_login();
  },
  methods: {
    handle_login: function () {
      var [buttonUAL] = document.body.getElementsByClassName("ual-button-gen");
      if (this.ual) {
        this.ual.init();
        buttonUAL.click();
        let elements = document.body.getElementsByClassName("ual-button-gen");
        while (elements.length > 0) {
          elements[0].parentNode.removeChild(elements[0]);
        }
      } else {
        const loginService = new LoginService();
        this.ual = loginService.handle_login();
        this.ual.init();
        buttonUAL.click();
        let elements = document.body.getElementsByClassName("ual-button-gen");
        while (elements.length > 0) {
          elements[0].parentNode.removeChild(elements[0]);
        }
      }
    },
  },
};
</script>

<style>
.ual-button-gen {
  display: none !important;
}
.ual-auth-text {
  display: inline-block !important;
  padding: 20px 4px 17px 10px !important;
  font-size: 10px !important;
  width: 137px !important;
}

.fa-chevron-right {
  font-size: 16px !important;
  float: right;
  margin: 12px 6px;
}

.ual-modal-content-description {
  /* color:#fff !important; */
  width: 246px !important;
  font-size: 1.2em !important;
  margin: 0.7em auto;
}
.logo {
  width: 300px;
}
.login {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  justify-content: center;
}
</style>